/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AboutRouteImport } from './routes/about'
import { Route as MainRouteImport } from './routes/_main'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as MainOnlineOrdersIndexRouteImport } from './routes/_main/online-orders/index'
import { Route as MainFloorPlanIndexRouteImport } from './routes/_main/floor-plan/index'
import { Route as MainCustomersIndexRouteImport } from './routes/_main/customers/index'
import { Route as MainCashRegisterIndexRouteImport } from './routes/_main/cash-register/index'
import { Route as MainAdminIndexRouteImport } from './routes/_main/admin/index'
import { Route as MainSettingsLayoutRouteImport } from './routes/_main/settings/_layout'
import { Route as MainReportsLayoutRouteImport } from './routes/_main/reports/_layout'
import { Route as MainBookingsLayoutRouteImport } from './routes/_main/bookings/_layout'
import { Route as MainSettingsLayoutIndexRouteImport } from './routes/_main/settings/_layout/index'
import { Route as MainReportsLayoutIndexRouteImport } from './routes/_main/reports/_layout/index'
import { Route as MainBookingsLayoutIndexRouteImport } from './routes/_main/bookings/_layout/index'
import { Route as MainAdminQrIndexRouteImport } from './routes/_main/admin/qr/index'
import { Route as MainAdminMerchantsIndexRouteImport } from './routes/_main/admin/merchants/index'
import { Route as MainAdminImporterIndexRouteImport } from './routes/_main/admin/importer/index'
import { Route as MainSettingsLayoutVatRatesRouteImport } from './routes/_main/settings/_layout/vat-rates'
import { Route as MainSettingsLayoutTablesRouteImport } from './routes/_main/settings/_layout/tables'
import { Route as MainSettingsLayoutTableCombinationsRouteImport } from './routes/_main/settings/_layout/table-combinations'
import { Route as MainSettingsLayoutSectionsRouteImport } from './routes/_main/settings/_layout/sections'
import { Route as MainSettingsLayoutPrintRoutesRouteImport } from './routes/_main/settings/_layout/print-routes'
import { Route as MainSettingsLayoutPricesRouteImport } from './routes/_main/settings/_layout/prices'
import { Route as MainSettingsLayoutPaymentMethodsRouteImport } from './routes/_main/settings/_layout/payment-methods'
import { Route as MainSettingsLayoutFloorPlanRouteImport } from './routes/_main/settings/_layout/floor-plan'
import { Route as MainSettingsLayoutEmployeesRouteImport } from './routes/_main/settings/_layout/employees'
import { Route as MainSettingsLayoutEmployeeGroupsRouteImport } from './routes/_main/settings/_layout/employee-groups'
import { Route as MainSettingsLayoutEmailRouteImport } from './routes/_main/settings/_layout/email'
import { Route as MainSettingsLayoutCompanyRouteImport } from './routes/_main/settings/_layout/company'
import { Route as MainSettingsLayoutAppearanceRouteImport } from './routes/_main/settings/_layout/appearance'
import { Route as MainReportsLayoutWeekRouteImport } from './routes/_main/reports/_layout/week'
import { Route as MainReportsLayoutVatRouteImport } from './routes/_main/reports/_layout/vat'
import { Route as MainReportsLayoutReceiptRouteImport } from './routes/_main/reports/_layout/receipt'
import { Route as MainReportsLayoutProductRouteImport } from './routes/_main/reports/_layout/product'
import { Route as MainReportsLayoutMutationRouteImport } from './routes/_main/reports/_layout/mutation'
import { Route as MainReportsLayoutMonthRouteImport } from './routes/_main/reports/_layout/month'
import { Route as MainReportsLayoutLabourRouteImport } from './routes/_main/reports/_layout/labour'
import { Route as MainReportsLayoutEmployeeRouteImport } from './routes/_main/reports/_layout/employee'
import { Route as MainReportsLayoutDayRouteImport } from './routes/_main/reports/_layout/day'
import { Route as MainReportsLayoutClosingRouteImport } from './routes/_main/reports/_layout/closing'
import { Route as MainReportsLayoutCategoryRouteImport } from './routes/_main/reports/_layout/category'
import { Route as MainBookingsLayoutTablePlanningRouteImport } from './routes/_main/bookings/_layout/table-planning'
import { Route as MainBookingsLayoutIndexcopyRouteImport } from './routes/_main/bookings/_layout/index copy'
import { Route as MainBookingsLayoutGuestPlanningRouteImport } from './routes/_main/bookings/_layout/guest-planning'
import { Route as MainSettingsLayoutProductsIndexRouteImport } from './routes/_main/settings/_layout/products/index'
import { Route as MainSettingsLayoutProductCategoriesIndexRouteImport } from './routes/_main/settings/_layout/product-categories/index'
import { Route as MainSettingsLayoutOnlineOrdersIndexRouteImport } from './routes/_main/settings/_layout/online-orders/index'
import { Route as MainSettingsLayoutMutationCategoriesIndexRouteImport } from './routes/_main/settings/_layout/mutation-categories/index'
import { Route as MainSettingsLayoutModifiersIndexRouteImport } from './routes/_main/settings/_layout/modifiers/index'
import { Route as MainSettingsLayoutModifierGroupsIndexRouteImport } from './routes/_main/settings/_layout/modifier-groups/index'
import { Route as MainSettingsLayoutLabelsIndexRouteImport } from './routes/_main/settings/_layout/labels/index'
import { Route as MainSettingsLayoutIntegrationsIndexRouteImport } from './routes/_main/settings/_layout/integrations/index'
import { Route as MainSettingsLayoutCoursesIndexRouteImport } from './routes/_main/settings/_layout/courses/index'
import { Route as MainSettingsLayoutCashRegisterIndexRouteImport } from './routes/_main/settings/_layout/cash-register/index'
import { Route as MainSettingsLayoutCashLocationsIndexRouteImport } from './routes/_main/settings/_layout/cash-locations/index'
import { Route as MainSettingsLayoutAccountIndexRouteImport } from './routes/_main/settings/_layout/account/index'
import { Route as MainSettingsLayoutIntegrationsMollieRouteImport } from './routes/_main/settings/_layout/integrations/mollie'
import { Route as MainSettingsLayoutDevicesPrintersRouteImport } from './routes/_main/settings/_layout/devices/printers'
import { Route as MainSettingsLayoutDevicesPaymentTerminalsRouteImport } from './routes/_main/settings/_layout/devices/payment-terminals'
import { Route as MainSettingsLayoutDevicesHandheldsRouteImport } from './routes/_main/settings/_layout/devices/handhelds'
import { Route as MainSettingsLayoutDevicesBaseStationsRouteImport } from './routes/_main/settings/_layout/devices/base-stations'
import { Route as MainSettingsLayoutCommunicationMessagesRouteImport } from './routes/_main/settings/_layout/communication/messages'
import { Route as MainSettingsLayoutCashRegisterTicketRouteImport } from './routes/_main/settings/_layout/cash-register/ticket'
import { Route as MainSettingsLayoutBookingsSpecialDaysRouteImport } from './routes/_main/settings/_layout/bookings/special-days'
import { Route as MainSettingsLayoutBookingsShiftsRouteImport } from './routes/_main/settings/_layout/bookings/shifts'
import { Route as MainSettingsLayoutBookingsServicesRouteImport } from './routes/_main/settings/_layout/bookings/services'
import { Route as MainSettingsLayoutBookingsBookingWidgetRouteImport } from './routes/_main/settings/_layout/bookings/booking-widget'
import { Route as MainSettingsLayoutAccountInvoicesRouteImport } from './routes/_main/settings/_layout/account/invoices'
import { Route as MainSettingsLayoutAccountContractsRouteImport } from './routes/_main/settings/_layout/account/contracts'
import { Route as MainSettingsLayoutOnlineOrdersShiftsIndexRouteImport } from './routes/_main/settings/_layout/online-orders/shifts/index'

const MainSettingsRouteImport = createFileRoute('/_main/settings')()
const MainReportsRouteImport = createFileRoute('/_main/reports')()
const MainBookingsRouteImport = createFileRoute('/_main/bookings')()

const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MainSettingsRoute = MainSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => MainRoute,
} as any)
const MainReportsRoute = MainReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => MainRoute,
} as any)
const MainBookingsRoute = MainBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => MainRoute,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const MainOnlineOrdersIndexRoute = MainOnlineOrdersIndexRouteImport.update({
  id: '/online-orders/',
  path: '/online-orders/',
  getParentRoute: () => MainRoute,
} as any)
const MainFloorPlanIndexRoute = MainFloorPlanIndexRouteImport.update({
  id: '/floor-plan/',
  path: '/floor-plan/',
  getParentRoute: () => MainRoute,
} as any)
const MainCustomersIndexRoute = MainCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => MainRoute,
} as any)
const MainCashRegisterIndexRoute = MainCashRegisterIndexRouteImport.update({
  id: '/cash-register/',
  path: '/cash-register/',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminIndexRoute = MainAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => MainRoute,
} as any)
const MainSettingsLayoutRoute = MainSettingsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => MainSettingsRoute,
} as any)
const MainReportsLayoutRoute = MainReportsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => MainReportsRoute,
} as any)
const MainBookingsLayoutRoute = MainBookingsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => MainBookingsRoute,
} as any)
const MainSettingsLayoutIndexRoute = MainSettingsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainSettingsLayoutRoute,
} as any)
const MainReportsLayoutIndexRoute = MainReportsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainBookingsLayoutIndexRoute = MainBookingsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainBookingsLayoutRoute,
} as any)
const MainAdminQrIndexRoute = MainAdminQrIndexRouteImport.update({
  id: '/admin/qr/',
  path: '/admin/qr/',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminMerchantsIndexRoute = MainAdminMerchantsIndexRouteImport.update({
  id: '/admin/merchants/',
  path: '/admin/merchants/',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminImporterIndexRoute = MainAdminImporterIndexRouteImport.update({
  id: '/admin/importer/',
  path: '/admin/importer/',
  getParentRoute: () => MainRoute,
} as any)
const MainSettingsLayoutVatRatesRoute =
  MainSettingsLayoutVatRatesRouteImport.update({
    id: '/vat-rates',
    path: '/vat-rates',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutTablesRoute =
  MainSettingsLayoutTablesRouteImport.update({
    id: '/tables',
    path: '/tables',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutTableCombinationsRoute =
  MainSettingsLayoutTableCombinationsRouteImport.update({
    id: '/table-combinations',
    path: '/table-combinations',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutSectionsRoute =
  MainSettingsLayoutSectionsRouteImport.update({
    id: '/sections',
    path: '/sections',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutPrintRoutesRoute =
  MainSettingsLayoutPrintRoutesRouteImport.update({
    id: '/print-routes',
    path: '/print-routes',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutPricesRoute =
  MainSettingsLayoutPricesRouteImport.update({
    id: '/prices',
    path: '/prices',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutPaymentMethodsRoute =
  MainSettingsLayoutPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutFloorPlanRoute =
  MainSettingsLayoutFloorPlanRouteImport.update({
    id: '/floor-plan',
    path: '/floor-plan',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutEmployeesRoute =
  MainSettingsLayoutEmployeesRouteImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutEmployeeGroupsRoute =
  MainSettingsLayoutEmployeeGroupsRouteImport.update({
    id: '/employee-groups',
    path: '/employee-groups',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutEmailRoute = MainSettingsLayoutEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => MainSettingsLayoutRoute,
} as any)
const MainSettingsLayoutCompanyRoute =
  MainSettingsLayoutCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutAppearanceRoute =
  MainSettingsLayoutAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainReportsLayoutWeekRoute = MainReportsLayoutWeekRouteImport.update({
  id: '/week',
  path: '/week',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainReportsLayoutVatRoute = MainReportsLayoutVatRouteImport.update({
  id: '/vat',
  path: '/vat',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainReportsLayoutReceiptRoute =
  MainReportsLayoutReceiptRouteImport.update({
    id: '/receipt',
    path: '/receipt',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainReportsLayoutProductRoute =
  MainReportsLayoutProductRouteImport.update({
    id: '/product',
    path: '/product',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainReportsLayoutMutationRoute =
  MainReportsLayoutMutationRouteImport.update({
    id: '/mutation',
    path: '/mutation',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainReportsLayoutMonthRoute = MainReportsLayoutMonthRouteImport.update({
  id: '/month',
  path: '/month',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainReportsLayoutLabourRoute = MainReportsLayoutLabourRouteImport.update({
  id: '/labour',
  path: '/labour',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainReportsLayoutEmployeeRoute =
  MainReportsLayoutEmployeeRouteImport.update({
    id: '/employee',
    path: '/employee',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainReportsLayoutDayRoute = MainReportsLayoutDayRouteImport.update({
  id: '/day',
  path: '/day',
  getParentRoute: () => MainReportsLayoutRoute,
} as any)
const MainReportsLayoutClosingRoute =
  MainReportsLayoutClosingRouteImport.update({
    id: '/closing',
    path: '/closing',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainReportsLayoutCategoryRoute =
  MainReportsLayoutCategoryRouteImport.update({
    id: '/category',
    path: '/category',
    getParentRoute: () => MainReportsLayoutRoute,
  } as any)
const MainBookingsLayoutTablePlanningRoute =
  MainBookingsLayoutTablePlanningRouteImport.update({
    id: '/table-planning',
    path: '/table-planning',
    getParentRoute: () => MainBookingsLayoutRoute,
  } as any)
const MainBookingsLayoutIndexcopyRoute =
  MainBookingsLayoutIndexcopyRouteImport.update({
    id: '/index copy',
    path: '/index copy',
    getParentRoute: () => MainBookingsLayoutRoute,
  } as any)
const MainBookingsLayoutGuestPlanningRoute =
  MainBookingsLayoutGuestPlanningRouteImport.update({
    id: '/guest-planning',
    path: '/guest-planning',
    getParentRoute: () => MainBookingsLayoutRoute,
  } as any)
const MainSettingsLayoutProductsIndexRoute =
  MainSettingsLayoutProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutProductCategoriesIndexRoute =
  MainSettingsLayoutProductCategoriesIndexRouteImport.update({
    id: '/product-categories/',
    path: '/product-categories/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutOnlineOrdersIndexRoute =
  MainSettingsLayoutOnlineOrdersIndexRouteImport.update({
    id: '/online-orders/',
    path: '/online-orders/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutMutationCategoriesIndexRoute =
  MainSettingsLayoutMutationCategoriesIndexRouteImport.update({
    id: '/mutation-categories/',
    path: '/mutation-categories/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutModifiersIndexRoute =
  MainSettingsLayoutModifiersIndexRouteImport.update({
    id: '/modifiers/',
    path: '/modifiers/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutModifierGroupsIndexRoute =
  MainSettingsLayoutModifierGroupsIndexRouteImport.update({
    id: '/modifier-groups/',
    path: '/modifier-groups/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutLabelsIndexRoute =
  MainSettingsLayoutLabelsIndexRouteImport.update({
    id: '/labels/',
    path: '/labels/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutIntegrationsIndexRoute =
  MainSettingsLayoutIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutCoursesIndexRoute =
  MainSettingsLayoutCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutCashRegisterIndexRoute =
  MainSettingsLayoutCashRegisterIndexRouteImport.update({
    id: '/cash-register/',
    path: '/cash-register/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutCashLocationsIndexRoute =
  MainSettingsLayoutCashLocationsIndexRouteImport.update({
    id: '/cash-locations/',
    path: '/cash-locations/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutAccountIndexRoute =
  MainSettingsLayoutAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutIntegrationsMollieRoute =
  MainSettingsLayoutIntegrationsMollieRouteImport.update({
    id: '/integrations/mollie',
    path: '/integrations/mollie',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutDevicesPrintersRoute =
  MainSettingsLayoutDevicesPrintersRouteImport.update({
    id: '/devices/printers',
    path: '/devices/printers',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutDevicesPaymentTerminalsRoute =
  MainSettingsLayoutDevicesPaymentTerminalsRouteImport.update({
    id: '/devices/payment-terminals',
    path: '/devices/payment-terminals',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutDevicesHandheldsRoute =
  MainSettingsLayoutDevicesHandheldsRouteImport.update({
    id: '/devices/handhelds',
    path: '/devices/handhelds',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutDevicesBaseStationsRoute =
  MainSettingsLayoutDevicesBaseStationsRouteImport.update({
    id: '/devices/base-stations',
    path: '/devices/base-stations',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutCommunicationMessagesRoute =
  MainSettingsLayoutCommunicationMessagesRouteImport.update({
    id: '/communication/messages',
    path: '/communication/messages',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutCashRegisterTicketRoute =
  MainSettingsLayoutCashRegisterTicketRouteImport.update({
    id: '/cash-register/ticket',
    path: '/cash-register/ticket',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutBookingsSpecialDaysRoute =
  MainSettingsLayoutBookingsSpecialDaysRouteImport.update({
    id: '/bookings/special-days',
    path: '/bookings/special-days',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutBookingsShiftsRoute =
  MainSettingsLayoutBookingsShiftsRouteImport.update({
    id: '/bookings/shifts',
    path: '/bookings/shifts',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutBookingsServicesRoute =
  MainSettingsLayoutBookingsServicesRouteImport.update({
    id: '/bookings/services',
    path: '/bookings/services',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutBookingsBookingWidgetRoute =
  MainSettingsLayoutBookingsBookingWidgetRouteImport.update({
    id: '/bookings/booking-widget',
    path: '/bookings/booking-widget',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutAccountInvoicesRoute =
  MainSettingsLayoutAccountInvoicesRouteImport.update({
    id: '/account/invoices',
    path: '/account/invoices',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutAccountContractsRoute =
  MainSettingsLayoutAccountContractsRouteImport.update({
    id: '/account/contracts',
    path: '/account/contracts',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)
const MainSettingsLayoutOnlineOrdersShiftsIndexRoute =
  MainSettingsLayoutOnlineOrdersShiftsIndexRouteImport.update({
    id: '/online-orders/shifts/',
    path: '/online-orders/shifts/',
    getParentRoute: () => MainSettingsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/about': typeof AboutRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/': typeof MainIndexRoute
  '/bookings': typeof MainBookingsLayoutRouteWithChildren
  '/reports': typeof MainReportsLayoutRouteWithChildren
  '/settings': typeof MainSettingsLayoutRouteWithChildren
  '/admin': typeof MainAdminIndexRoute
  '/cash-register': typeof MainCashRegisterIndexRoute
  '/customers': typeof MainCustomersIndexRoute
  '/floor-plan': typeof MainFloorPlanIndexRoute
  '/online-orders': typeof MainOnlineOrdersIndexRoute
  '/bookings/guest-planning': typeof MainBookingsLayoutGuestPlanningRoute
  '/bookings/index copy': typeof MainBookingsLayoutIndexcopyRoute
  '/bookings/table-planning': typeof MainBookingsLayoutTablePlanningRoute
  '/reports/category': typeof MainReportsLayoutCategoryRoute
  '/reports/closing': typeof MainReportsLayoutClosingRoute
  '/reports/day': typeof MainReportsLayoutDayRoute
  '/reports/employee': typeof MainReportsLayoutEmployeeRoute
  '/reports/labour': typeof MainReportsLayoutLabourRoute
  '/reports/month': typeof MainReportsLayoutMonthRoute
  '/reports/mutation': typeof MainReportsLayoutMutationRoute
  '/reports/product': typeof MainReportsLayoutProductRoute
  '/reports/receipt': typeof MainReportsLayoutReceiptRoute
  '/reports/vat': typeof MainReportsLayoutVatRoute
  '/reports/week': typeof MainReportsLayoutWeekRoute
  '/settings/appearance': typeof MainSettingsLayoutAppearanceRoute
  '/settings/company': typeof MainSettingsLayoutCompanyRoute
  '/settings/email': typeof MainSettingsLayoutEmailRoute
  '/settings/employee-groups': typeof MainSettingsLayoutEmployeeGroupsRoute
  '/settings/employees': typeof MainSettingsLayoutEmployeesRoute
  '/settings/floor-plan': typeof MainSettingsLayoutFloorPlanRoute
  '/settings/payment-methods': typeof MainSettingsLayoutPaymentMethodsRoute
  '/settings/prices': typeof MainSettingsLayoutPricesRoute
  '/settings/print-routes': typeof MainSettingsLayoutPrintRoutesRoute
  '/settings/sections': typeof MainSettingsLayoutSectionsRoute
  '/settings/table-combinations': typeof MainSettingsLayoutTableCombinationsRoute
  '/settings/tables': typeof MainSettingsLayoutTablesRoute
  '/settings/vat-rates': typeof MainSettingsLayoutVatRatesRoute
  '/admin/importer': typeof MainAdminImporterIndexRoute
  '/admin/merchants': typeof MainAdminMerchantsIndexRoute
  '/admin/qr': typeof MainAdminQrIndexRoute
  '/bookings/': typeof MainBookingsLayoutIndexRoute
  '/reports/': typeof MainReportsLayoutIndexRoute
  '/settings/': typeof MainSettingsLayoutIndexRoute
  '/settings/account/contracts': typeof MainSettingsLayoutAccountContractsRoute
  '/settings/account/invoices': typeof MainSettingsLayoutAccountInvoicesRoute
  '/settings/bookings/booking-widget': typeof MainSettingsLayoutBookingsBookingWidgetRoute
  '/settings/bookings/services': typeof MainSettingsLayoutBookingsServicesRoute
  '/settings/bookings/shifts': typeof MainSettingsLayoutBookingsShiftsRoute
  '/settings/bookings/special-days': typeof MainSettingsLayoutBookingsSpecialDaysRoute
  '/settings/cash-register/ticket': typeof MainSettingsLayoutCashRegisterTicketRoute
  '/settings/communication/messages': typeof MainSettingsLayoutCommunicationMessagesRoute
  '/settings/devices/base-stations': typeof MainSettingsLayoutDevicesBaseStationsRoute
  '/settings/devices/handhelds': typeof MainSettingsLayoutDevicesHandheldsRoute
  '/settings/devices/payment-terminals': typeof MainSettingsLayoutDevicesPaymentTerminalsRoute
  '/settings/devices/printers': typeof MainSettingsLayoutDevicesPrintersRoute
  '/settings/integrations/mollie': typeof MainSettingsLayoutIntegrationsMollieRoute
  '/settings/account': typeof MainSettingsLayoutAccountIndexRoute
  '/settings/cash-locations': typeof MainSettingsLayoutCashLocationsIndexRoute
  '/settings/cash-register': typeof MainSettingsLayoutCashRegisterIndexRoute
  '/settings/courses': typeof MainSettingsLayoutCoursesIndexRoute
  '/settings/integrations': typeof MainSettingsLayoutIntegrationsIndexRoute
  '/settings/labels': typeof MainSettingsLayoutLabelsIndexRoute
  '/settings/modifier-groups': typeof MainSettingsLayoutModifierGroupsIndexRoute
  '/settings/modifiers': typeof MainSettingsLayoutModifiersIndexRoute
  '/settings/mutation-categories': typeof MainSettingsLayoutMutationCategoriesIndexRoute
  '/settings/online-orders': typeof MainSettingsLayoutOnlineOrdersIndexRoute
  '/settings/product-categories': typeof MainSettingsLayoutProductCategoriesIndexRoute
  '/settings/products': typeof MainSettingsLayoutProductsIndexRoute
  '/settings/online-orders/shifts': typeof MainSettingsLayoutOnlineOrdersShiftsIndexRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/': typeof MainIndexRoute
  '/bookings': typeof MainBookingsLayoutIndexRoute
  '/reports': typeof MainReportsLayoutIndexRoute
  '/settings': typeof MainSettingsLayoutIndexRoute
  '/admin': typeof MainAdminIndexRoute
  '/cash-register': typeof MainCashRegisterIndexRoute
  '/customers': typeof MainCustomersIndexRoute
  '/floor-plan': typeof MainFloorPlanIndexRoute
  '/online-orders': typeof MainOnlineOrdersIndexRoute
  '/bookings/guest-planning': typeof MainBookingsLayoutGuestPlanningRoute
  '/bookings/index copy': typeof MainBookingsLayoutIndexcopyRoute
  '/bookings/table-planning': typeof MainBookingsLayoutTablePlanningRoute
  '/reports/category': typeof MainReportsLayoutCategoryRoute
  '/reports/closing': typeof MainReportsLayoutClosingRoute
  '/reports/day': typeof MainReportsLayoutDayRoute
  '/reports/employee': typeof MainReportsLayoutEmployeeRoute
  '/reports/labour': typeof MainReportsLayoutLabourRoute
  '/reports/month': typeof MainReportsLayoutMonthRoute
  '/reports/mutation': typeof MainReportsLayoutMutationRoute
  '/reports/product': typeof MainReportsLayoutProductRoute
  '/reports/receipt': typeof MainReportsLayoutReceiptRoute
  '/reports/vat': typeof MainReportsLayoutVatRoute
  '/reports/week': typeof MainReportsLayoutWeekRoute
  '/settings/appearance': typeof MainSettingsLayoutAppearanceRoute
  '/settings/company': typeof MainSettingsLayoutCompanyRoute
  '/settings/email': typeof MainSettingsLayoutEmailRoute
  '/settings/employee-groups': typeof MainSettingsLayoutEmployeeGroupsRoute
  '/settings/employees': typeof MainSettingsLayoutEmployeesRoute
  '/settings/floor-plan': typeof MainSettingsLayoutFloorPlanRoute
  '/settings/payment-methods': typeof MainSettingsLayoutPaymentMethodsRoute
  '/settings/prices': typeof MainSettingsLayoutPricesRoute
  '/settings/print-routes': typeof MainSettingsLayoutPrintRoutesRoute
  '/settings/sections': typeof MainSettingsLayoutSectionsRoute
  '/settings/table-combinations': typeof MainSettingsLayoutTableCombinationsRoute
  '/settings/tables': typeof MainSettingsLayoutTablesRoute
  '/settings/vat-rates': typeof MainSettingsLayoutVatRatesRoute
  '/admin/importer': typeof MainAdminImporterIndexRoute
  '/admin/merchants': typeof MainAdminMerchantsIndexRoute
  '/admin/qr': typeof MainAdminQrIndexRoute
  '/settings/account/contracts': typeof MainSettingsLayoutAccountContractsRoute
  '/settings/account/invoices': typeof MainSettingsLayoutAccountInvoicesRoute
  '/settings/bookings/booking-widget': typeof MainSettingsLayoutBookingsBookingWidgetRoute
  '/settings/bookings/services': typeof MainSettingsLayoutBookingsServicesRoute
  '/settings/bookings/shifts': typeof MainSettingsLayoutBookingsShiftsRoute
  '/settings/bookings/special-days': typeof MainSettingsLayoutBookingsSpecialDaysRoute
  '/settings/cash-register/ticket': typeof MainSettingsLayoutCashRegisterTicketRoute
  '/settings/communication/messages': typeof MainSettingsLayoutCommunicationMessagesRoute
  '/settings/devices/base-stations': typeof MainSettingsLayoutDevicesBaseStationsRoute
  '/settings/devices/handhelds': typeof MainSettingsLayoutDevicesHandheldsRoute
  '/settings/devices/payment-terminals': typeof MainSettingsLayoutDevicesPaymentTerminalsRoute
  '/settings/devices/printers': typeof MainSettingsLayoutDevicesPrintersRoute
  '/settings/integrations/mollie': typeof MainSettingsLayoutIntegrationsMollieRoute
  '/settings/account': typeof MainSettingsLayoutAccountIndexRoute
  '/settings/cash-locations': typeof MainSettingsLayoutCashLocationsIndexRoute
  '/settings/cash-register': typeof MainSettingsLayoutCashRegisterIndexRoute
  '/settings/courses': typeof MainSettingsLayoutCoursesIndexRoute
  '/settings/integrations': typeof MainSettingsLayoutIntegrationsIndexRoute
  '/settings/labels': typeof MainSettingsLayoutLabelsIndexRoute
  '/settings/modifier-groups': typeof MainSettingsLayoutModifierGroupsIndexRoute
  '/settings/modifiers': typeof MainSettingsLayoutModifiersIndexRoute
  '/settings/mutation-categories': typeof MainSettingsLayoutMutationCategoriesIndexRoute
  '/settings/online-orders': typeof MainSettingsLayoutOnlineOrdersIndexRoute
  '/settings/product-categories': typeof MainSettingsLayoutProductCategoriesIndexRoute
  '/settings/products': typeof MainSettingsLayoutProductsIndexRoute
  '/settings/online-orders/shifts': typeof MainSettingsLayoutOnlineOrdersShiftsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/about': typeof AboutRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_main/': typeof MainIndexRoute
  '/_main/bookings': typeof MainBookingsRouteWithChildren
  '/_main/bookings/_layout': typeof MainBookingsLayoutRouteWithChildren
  '/_main/reports': typeof MainReportsRouteWithChildren
  '/_main/reports/_layout': typeof MainReportsLayoutRouteWithChildren
  '/_main/settings': typeof MainSettingsRouteWithChildren
  '/_main/settings/_layout': typeof MainSettingsLayoutRouteWithChildren
  '/_main/admin/': typeof MainAdminIndexRoute
  '/_main/cash-register/': typeof MainCashRegisterIndexRoute
  '/_main/customers/': typeof MainCustomersIndexRoute
  '/_main/floor-plan/': typeof MainFloorPlanIndexRoute
  '/_main/online-orders/': typeof MainOnlineOrdersIndexRoute
  '/_main/bookings/_layout/guest-planning': typeof MainBookingsLayoutGuestPlanningRoute
  '/_main/bookings/_layout/index copy': typeof MainBookingsLayoutIndexcopyRoute
  '/_main/bookings/_layout/table-planning': typeof MainBookingsLayoutTablePlanningRoute
  '/_main/reports/_layout/category': typeof MainReportsLayoutCategoryRoute
  '/_main/reports/_layout/closing': typeof MainReportsLayoutClosingRoute
  '/_main/reports/_layout/day': typeof MainReportsLayoutDayRoute
  '/_main/reports/_layout/employee': typeof MainReportsLayoutEmployeeRoute
  '/_main/reports/_layout/labour': typeof MainReportsLayoutLabourRoute
  '/_main/reports/_layout/month': typeof MainReportsLayoutMonthRoute
  '/_main/reports/_layout/mutation': typeof MainReportsLayoutMutationRoute
  '/_main/reports/_layout/product': typeof MainReportsLayoutProductRoute
  '/_main/reports/_layout/receipt': typeof MainReportsLayoutReceiptRoute
  '/_main/reports/_layout/vat': typeof MainReportsLayoutVatRoute
  '/_main/reports/_layout/week': typeof MainReportsLayoutWeekRoute
  '/_main/settings/_layout/appearance': typeof MainSettingsLayoutAppearanceRoute
  '/_main/settings/_layout/company': typeof MainSettingsLayoutCompanyRoute
  '/_main/settings/_layout/email': typeof MainSettingsLayoutEmailRoute
  '/_main/settings/_layout/employee-groups': typeof MainSettingsLayoutEmployeeGroupsRoute
  '/_main/settings/_layout/employees': typeof MainSettingsLayoutEmployeesRoute
  '/_main/settings/_layout/floor-plan': typeof MainSettingsLayoutFloorPlanRoute
  '/_main/settings/_layout/payment-methods': typeof MainSettingsLayoutPaymentMethodsRoute
  '/_main/settings/_layout/prices': typeof MainSettingsLayoutPricesRoute
  '/_main/settings/_layout/print-routes': typeof MainSettingsLayoutPrintRoutesRoute
  '/_main/settings/_layout/sections': typeof MainSettingsLayoutSectionsRoute
  '/_main/settings/_layout/table-combinations': typeof MainSettingsLayoutTableCombinationsRoute
  '/_main/settings/_layout/tables': typeof MainSettingsLayoutTablesRoute
  '/_main/settings/_layout/vat-rates': typeof MainSettingsLayoutVatRatesRoute
  '/_main/admin/importer/': typeof MainAdminImporterIndexRoute
  '/_main/admin/merchants/': typeof MainAdminMerchantsIndexRoute
  '/_main/admin/qr/': typeof MainAdminQrIndexRoute
  '/_main/bookings/_layout/': typeof MainBookingsLayoutIndexRoute
  '/_main/reports/_layout/': typeof MainReportsLayoutIndexRoute
  '/_main/settings/_layout/': typeof MainSettingsLayoutIndexRoute
  '/_main/settings/_layout/account/contracts': typeof MainSettingsLayoutAccountContractsRoute
  '/_main/settings/_layout/account/invoices': typeof MainSettingsLayoutAccountInvoicesRoute
  '/_main/settings/_layout/bookings/booking-widget': typeof MainSettingsLayoutBookingsBookingWidgetRoute
  '/_main/settings/_layout/bookings/services': typeof MainSettingsLayoutBookingsServicesRoute
  '/_main/settings/_layout/bookings/shifts': typeof MainSettingsLayoutBookingsShiftsRoute
  '/_main/settings/_layout/bookings/special-days': typeof MainSettingsLayoutBookingsSpecialDaysRoute
  '/_main/settings/_layout/cash-register/ticket': typeof MainSettingsLayoutCashRegisterTicketRoute
  '/_main/settings/_layout/communication/messages': typeof MainSettingsLayoutCommunicationMessagesRoute
  '/_main/settings/_layout/devices/base-stations': typeof MainSettingsLayoutDevicesBaseStationsRoute
  '/_main/settings/_layout/devices/handhelds': typeof MainSettingsLayoutDevicesHandheldsRoute
  '/_main/settings/_layout/devices/payment-terminals': typeof MainSettingsLayoutDevicesPaymentTerminalsRoute
  '/_main/settings/_layout/devices/printers': typeof MainSettingsLayoutDevicesPrintersRoute
  '/_main/settings/_layout/integrations/mollie': typeof MainSettingsLayoutIntegrationsMollieRoute
  '/_main/settings/_layout/account/': typeof MainSettingsLayoutAccountIndexRoute
  '/_main/settings/_layout/cash-locations/': typeof MainSettingsLayoutCashLocationsIndexRoute
  '/_main/settings/_layout/cash-register/': typeof MainSettingsLayoutCashRegisterIndexRoute
  '/_main/settings/_layout/courses/': typeof MainSettingsLayoutCoursesIndexRoute
  '/_main/settings/_layout/integrations/': typeof MainSettingsLayoutIntegrationsIndexRoute
  '/_main/settings/_layout/labels/': typeof MainSettingsLayoutLabelsIndexRoute
  '/_main/settings/_layout/modifier-groups/': typeof MainSettingsLayoutModifierGroupsIndexRoute
  '/_main/settings/_layout/modifiers/': typeof MainSettingsLayoutModifiersIndexRoute
  '/_main/settings/_layout/mutation-categories/': typeof MainSettingsLayoutMutationCategoriesIndexRoute
  '/_main/settings/_layout/online-orders/': typeof MainSettingsLayoutOnlineOrdersIndexRoute
  '/_main/settings/_layout/product-categories/': typeof MainSettingsLayoutProductCategoriesIndexRoute
  '/_main/settings/_layout/products/': typeof MainSettingsLayoutProductsIndexRoute
  '/_main/settings/_layout/online-orders/shifts/': typeof MainSettingsLayoutOnlineOrdersShiftsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/about'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/'
    | '/bookings'
    | '/reports'
    | '/settings'
    | '/admin'
    | '/cash-register'
    | '/customers'
    | '/floor-plan'
    | '/online-orders'
    | '/bookings/guest-planning'
    | '/bookings/index copy'
    | '/bookings/table-planning'
    | '/reports/category'
    | '/reports/closing'
    | '/reports/day'
    | '/reports/employee'
    | '/reports/labour'
    | '/reports/month'
    | '/reports/mutation'
    | '/reports/product'
    | '/reports/receipt'
    | '/reports/vat'
    | '/reports/week'
    | '/settings/appearance'
    | '/settings/company'
    | '/settings/email'
    | '/settings/employee-groups'
    | '/settings/employees'
    | '/settings/floor-plan'
    | '/settings/payment-methods'
    | '/settings/prices'
    | '/settings/print-routes'
    | '/settings/sections'
    | '/settings/table-combinations'
    | '/settings/tables'
    | '/settings/vat-rates'
    | '/admin/importer'
    | '/admin/merchants'
    | '/admin/qr'
    | '/bookings/'
    | '/reports/'
    | '/settings/'
    | '/settings/account/contracts'
    | '/settings/account/invoices'
    | '/settings/bookings/booking-widget'
    | '/settings/bookings/services'
    | '/settings/bookings/shifts'
    | '/settings/bookings/special-days'
    | '/settings/cash-register/ticket'
    | '/settings/communication/messages'
    | '/settings/devices/base-stations'
    | '/settings/devices/handhelds'
    | '/settings/devices/payment-terminals'
    | '/settings/devices/printers'
    | '/settings/integrations/mollie'
    | '/settings/account'
    | '/settings/cash-locations'
    | '/settings/cash-register'
    | '/settings/courses'
    | '/settings/integrations'
    | '/settings/labels'
    | '/settings/modifier-groups'
    | '/settings/modifiers'
    | '/settings/mutation-categories'
    | '/settings/online-orders'
    | '/settings/product-categories'
    | '/settings/products'
    | '/settings/online-orders/shifts'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/'
    | '/bookings'
    | '/reports'
    | '/settings'
    | '/admin'
    | '/cash-register'
    | '/customers'
    | '/floor-plan'
    | '/online-orders'
    | '/bookings/guest-planning'
    | '/bookings/index copy'
    | '/bookings/table-planning'
    | '/reports/category'
    | '/reports/closing'
    | '/reports/day'
    | '/reports/employee'
    | '/reports/labour'
    | '/reports/month'
    | '/reports/mutation'
    | '/reports/product'
    | '/reports/receipt'
    | '/reports/vat'
    | '/reports/week'
    | '/settings/appearance'
    | '/settings/company'
    | '/settings/email'
    | '/settings/employee-groups'
    | '/settings/employees'
    | '/settings/floor-plan'
    | '/settings/payment-methods'
    | '/settings/prices'
    | '/settings/print-routes'
    | '/settings/sections'
    | '/settings/table-combinations'
    | '/settings/tables'
    | '/settings/vat-rates'
    | '/admin/importer'
    | '/admin/merchants'
    | '/admin/qr'
    | '/settings/account/contracts'
    | '/settings/account/invoices'
    | '/settings/bookings/booking-widget'
    | '/settings/bookings/services'
    | '/settings/bookings/shifts'
    | '/settings/bookings/special-days'
    | '/settings/cash-register/ticket'
    | '/settings/communication/messages'
    | '/settings/devices/base-stations'
    | '/settings/devices/handhelds'
    | '/settings/devices/payment-terminals'
    | '/settings/devices/printers'
    | '/settings/integrations/mollie'
    | '/settings/account'
    | '/settings/cash-locations'
    | '/settings/cash-register'
    | '/settings/courses'
    | '/settings/integrations'
    | '/settings/labels'
    | '/settings/modifier-groups'
    | '/settings/modifiers'
    | '/settings/mutation-categories'
    | '/settings/online-orders'
    | '/settings/product-categories'
    | '/settings/products'
    | '/settings/online-orders/shifts'
  id:
    | '__root__'
    | '/_auth'
    | '/_main'
    | '/about'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_main/'
    | '/_main/bookings'
    | '/_main/bookings/_layout'
    | '/_main/reports'
    | '/_main/reports/_layout'
    | '/_main/settings'
    | '/_main/settings/_layout'
    | '/_main/admin/'
    | '/_main/cash-register/'
    | '/_main/customers/'
    | '/_main/floor-plan/'
    | '/_main/online-orders/'
    | '/_main/bookings/_layout/guest-planning'
    | '/_main/bookings/_layout/index copy'
    | '/_main/bookings/_layout/table-planning'
    | '/_main/reports/_layout/category'
    | '/_main/reports/_layout/closing'
    | '/_main/reports/_layout/day'
    | '/_main/reports/_layout/employee'
    | '/_main/reports/_layout/labour'
    | '/_main/reports/_layout/month'
    | '/_main/reports/_layout/mutation'
    | '/_main/reports/_layout/product'
    | '/_main/reports/_layout/receipt'
    | '/_main/reports/_layout/vat'
    | '/_main/reports/_layout/week'
    | '/_main/settings/_layout/appearance'
    | '/_main/settings/_layout/company'
    | '/_main/settings/_layout/email'
    | '/_main/settings/_layout/employee-groups'
    | '/_main/settings/_layout/employees'
    | '/_main/settings/_layout/floor-plan'
    | '/_main/settings/_layout/payment-methods'
    | '/_main/settings/_layout/prices'
    | '/_main/settings/_layout/print-routes'
    | '/_main/settings/_layout/sections'
    | '/_main/settings/_layout/table-combinations'
    | '/_main/settings/_layout/tables'
    | '/_main/settings/_layout/vat-rates'
    | '/_main/admin/importer/'
    | '/_main/admin/merchants/'
    | '/_main/admin/qr/'
    | '/_main/bookings/_layout/'
    | '/_main/reports/_layout/'
    | '/_main/settings/_layout/'
    | '/_main/settings/_layout/account/contracts'
    | '/_main/settings/_layout/account/invoices'
    | '/_main/settings/_layout/bookings/booking-widget'
    | '/_main/settings/_layout/bookings/services'
    | '/_main/settings/_layout/bookings/shifts'
    | '/_main/settings/_layout/bookings/special-days'
    | '/_main/settings/_layout/cash-register/ticket'
    | '/_main/settings/_layout/communication/messages'
    | '/_main/settings/_layout/devices/base-stations'
    | '/_main/settings/_layout/devices/handhelds'
    | '/_main/settings/_layout/devices/payment-terminals'
    | '/_main/settings/_layout/devices/printers'
    | '/_main/settings/_layout/integrations/mollie'
    | '/_main/settings/_layout/account/'
    | '/_main/settings/_layout/cash-locations/'
    | '/_main/settings/_layout/cash-register/'
    | '/_main/settings/_layout/courses/'
    | '/_main/settings/_layout/integrations/'
    | '/_main/settings/_layout/labels/'
    | '/_main/settings/_layout/modifier-groups/'
    | '/_main/settings/_layout/modifiers/'
    | '/_main/settings/_layout/mutation-categories/'
    | '/_main/settings/_layout/online-orders/'
    | '/_main/settings/_layout/product-categories/'
    | '/_main/settings/_layout/products/'
    | '/_main/settings/_layout/online-orders/shifts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  AboutRoute: typeof AboutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/settings': {
      id: '/_main/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MainSettingsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports': {
      id: '/_main/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof MainReportsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/bookings': {
      id: '/_main/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof MainBookingsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_main/online-orders/': {
      id: '/_main/online-orders/'
      path: '/online-orders'
      fullPath: '/online-orders'
      preLoaderRoute: typeof MainOnlineOrdersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/floor-plan/': {
      id: '/_main/floor-plan/'
      path: '/floor-plan'
      fullPath: '/floor-plan'
      preLoaderRoute: typeof MainFloorPlanIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/customers/': {
      id: '/_main/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof MainCustomersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/cash-register/': {
      id: '/_main/cash-register/'
      path: '/cash-register'
      fullPath: '/cash-register'
      preLoaderRoute: typeof MainCashRegisterIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin/': {
      id: '/_main/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof MainAdminIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings/_layout': {
      id: '/_main/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MainSettingsLayoutRouteImport
      parentRoute: typeof MainSettingsRoute
    }
    '/_main/reports/_layout': {
      id: '/_main/reports/_layout'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof MainReportsLayoutRouteImport
      parentRoute: typeof MainReportsRoute
    }
    '/_main/bookings/_layout': {
      id: '/_main/bookings/_layout'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof MainBookingsLayoutRouteImport
      parentRoute: typeof MainBookingsRoute
    }
    '/_main/settings/_layout/': {
      id: '/_main/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof MainSettingsLayoutIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/reports/_layout/': {
      id: '/_main/reports/_layout/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof MainReportsLayoutIndexRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/bookings/_layout/': {
      id: '/_main/bookings/_layout/'
      path: '/'
      fullPath: '/bookings/'
      preLoaderRoute: typeof MainBookingsLayoutIndexRouteImport
      parentRoute: typeof MainBookingsLayoutRoute
    }
    '/_main/admin/qr/': {
      id: '/_main/admin/qr/'
      path: '/admin/qr'
      fullPath: '/admin/qr'
      preLoaderRoute: typeof MainAdminQrIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin/merchants/': {
      id: '/_main/admin/merchants/'
      path: '/admin/merchants'
      fullPath: '/admin/merchants'
      preLoaderRoute: typeof MainAdminMerchantsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin/importer/': {
      id: '/_main/admin/importer/'
      path: '/admin/importer'
      fullPath: '/admin/importer'
      preLoaderRoute: typeof MainAdminImporterIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings/_layout/vat-rates': {
      id: '/_main/settings/_layout/vat-rates'
      path: '/vat-rates'
      fullPath: '/settings/vat-rates'
      preLoaderRoute: typeof MainSettingsLayoutVatRatesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/tables': {
      id: '/_main/settings/_layout/tables'
      path: '/tables'
      fullPath: '/settings/tables'
      preLoaderRoute: typeof MainSettingsLayoutTablesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/table-combinations': {
      id: '/_main/settings/_layout/table-combinations'
      path: '/table-combinations'
      fullPath: '/settings/table-combinations'
      preLoaderRoute: typeof MainSettingsLayoutTableCombinationsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/sections': {
      id: '/_main/settings/_layout/sections'
      path: '/sections'
      fullPath: '/settings/sections'
      preLoaderRoute: typeof MainSettingsLayoutSectionsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/print-routes': {
      id: '/_main/settings/_layout/print-routes'
      path: '/print-routes'
      fullPath: '/settings/print-routes'
      preLoaderRoute: typeof MainSettingsLayoutPrintRoutesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/prices': {
      id: '/_main/settings/_layout/prices'
      path: '/prices'
      fullPath: '/settings/prices'
      preLoaderRoute: typeof MainSettingsLayoutPricesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/payment-methods': {
      id: '/_main/settings/_layout/payment-methods'
      path: '/payment-methods'
      fullPath: '/settings/payment-methods'
      preLoaderRoute: typeof MainSettingsLayoutPaymentMethodsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/floor-plan': {
      id: '/_main/settings/_layout/floor-plan'
      path: '/floor-plan'
      fullPath: '/settings/floor-plan'
      preLoaderRoute: typeof MainSettingsLayoutFloorPlanRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/employees': {
      id: '/_main/settings/_layout/employees'
      path: '/employees'
      fullPath: '/settings/employees'
      preLoaderRoute: typeof MainSettingsLayoutEmployeesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/employee-groups': {
      id: '/_main/settings/_layout/employee-groups'
      path: '/employee-groups'
      fullPath: '/settings/employee-groups'
      preLoaderRoute: typeof MainSettingsLayoutEmployeeGroupsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/email': {
      id: '/_main/settings/_layout/email'
      path: '/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof MainSettingsLayoutEmailRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/company': {
      id: '/_main/settings/_layout/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof MainSettingsLayoutCompanyRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/appearance': {
      id: '/_main/settings/_layout/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof MainSettingsLayoutAppearanceRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/reports/_layout/week': {
      id: '/_main/reports/_layout/week'
      path: '/week'
      fullPath: '/reports/week'
      preLoaderRoute: typeof MainReportsLayoutWeekRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/vat': {
      id: '/_main/reports/_layout/vat'
      path: '/vat'
      fullPath: '/reports/vat'
      preLoaderRoute: typeof MainReportsLayoutVatRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/receipt': {
      id: '/_main/reports/_layout/receipt'
      path: '/receipt'
      fullPath: '/reports/receipt'
      preLoaderRoute: typeof MainReportsLayoutReceiptRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/product': {
      id: '/_main/reports/_layout/product'
      path: '/product'
      fullPath: '/reports/product'
      preLoaderRoute: typeof MainReportsLayoutProductRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/mutation': {
      id: '/_main/reports/_layout/mutation'
      path: '/mutation'
      fullPath: '/reports/mutation'
      preLoaderRoute: typeof MainReportsLayoutMutationRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/month': {
      id: '/_main/reports/_layout/month'
      path: '/month'
      fullPath: '/reports/month'
      preLoaderRoute: typeof MainReportsLayoutMonthRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/labour': {
      id: '/_main/reports/_layout/labour'
      path: '/labour'
      fullPath: '/reports/labour'
      preLoaderRoute: typeof MainReportsLayoutLabourRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/employee': {
      id: '/_main/reports/_layout/employee'
      path: '/employee'
      fullPath: '/reports/employee'
      preLoaderRoute: typeof MainReportsLayoutEmployeeRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/day': {
      id: '/_main/reports/_layout/day'
      path: '/day'
      fullPath: '/reports/day'
      preLoaderRoute: typeof MainReportsLayoutDayRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/closing': {
      id: '/_main/reports/_layout/closing'
      path: '/closing'
      fullPath: '/reports/closing'
      preLoaderRoute: typeof MainReportsLayoutClosingRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/reports/_layout/category': {
      id: '/_main/reports/_layout/category'
      path: '/category'
      fullPath: '/reports/category'
      preLoaderRoute: typeof MainReportsLayoutCategoryRouteImport
      parentRoute: typeof MainReportsLayoutRoute
    }
    '/_main/bookings/_layout/table-planning': {
      id: '/_main/bookings/_layout/table-planning'
      path: '/table-planning'
      fullPath: '/bookings/table-planning'
      preLoaderRoute: typeof MainBookingsLayoutTablePlanningRouteImport
      parentRoute: typeof MainBookingsLayoutRoute
    }
    '/_main/bookings/_layout/index copy': {
      id: '/_main/bookings/_layout/index copy'
      path: '/index copy'
      fullPath: '/bookings/index copy'
      preLoaderRoute: typeof MainBookingsLayoutIndexcopyRouteImport
      parentRoute: typeof MainBookingsLayoutRoute
    }
    '/_main/bookings/_layout/guest-planning': {
      id: '/_main/bookings/_layout/guest-planning'
      path: '/guest-planning'
      fullPath: '/bookings/guest-planning'
      preLoaderRoute: typeof MainBookingsLayoutGuestPlanningRouteImport
      parentRoute: typeof MainBookingsLayoutRoute
    }
    '/_main/settings/_layout/products/': {
      id: '/_main/settings/_layout/products/'
      path: '/products'
      fullPath: '/settings/products'
      preLoaderRoute: typeof MainSettingsLayoutProductsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/product-categories/': {
      id: '/_main/settings/_layout/product-categories/'
      path: '/product-categories'
      fullPath: '/settings/product-categories'
      preLoaderRoute: typeof MainSettingsLayoutProductCategoriesIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/online-orders/': {
      id: '/_main/settings/_layout/online-orders/'
      path: '/online-orders'
      fullPath: '/settings/online-orders'
      preLoaderRoute: typeof MainSettingsLayoutOnlineOrdersIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/mutation-categories/': {
      id: '/_main/settings/_layout/mutation-categories/'
      path: '/mutation-categories'
      fullPath: '/settings/mutation-categories'
      preLoaderRoute: typeof MainSettingsLayoutMutationCategoriesIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/modifiers/': {
      id: '/_main/settings/_layout/modifiers/'
      path: '/modifiers'
      fullPath: '/settings/modifiers'
      preLoaderRoute: typeof MainSettingsLayoutModifiersIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/modifier-groups/': {
      id: '/_main/settings/_layout/modifier-groups/'
      path: '/modifier-groups'
      fullPath: '/settings/modifier-groups'
      preLoaderRoute: typeof MainSettingsLayoutModifierGroupsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/labels/': {
      id: '/_main/settings/_layout/labels/'
      path: '/labels'
      fullPath: '/settings/labels'
      preLoaderRoute: typeof MainSettingsLayoutLabelsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/integrations/': {
      id: '/_main/settings/_layout/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof MainSettingsLayoutIntegrationsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/courses/': {
      id: '/_main/settings/_layout/courses/'
      path: '/courses'
      fullPath: '/settings/courses'
      preLoaderRoute: typeof MainSettingsLayoutCoursesIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/cash-register/': {
      id: '/_main/settings/_layout/cash-register/'
      path: '/cash-register'
      fullPath: '/settings/cash-register'
      preLoaderRoute: typeof MainSettingsLayoutCashRegisterIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/cash-locations/': {
      id: '/_main/settings/_layout/cash-locations/'
      path: '/cash-locations'
      fullPath: '/settings/cash-locations'
      preLoaderRoute: typeof MainSettingsLayoutCashLocationsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/account/': {
      id: '/_main/settings/_layout/account/'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof MainSettingsLayoutAccountIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/integrations/mollie': {
      id: '/_main/settings/_layout/integrations/mollie'
      path: '/integrations/mollie'
      fullPath: '/settings/integrations/mollie'
      preLoaderRoute: typeof MainSettingsLayoutIntegrationsMollieRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/devices/printers': {
      id: '/_main/settings/_layout/devices/printers'
      path: '/devices/printers'
      fullPath: '/settings/devices/printers'
      preLoaderRoute: typeof MainSettingsLayoutDevicesPrintersRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/devices/payment-terminals': {
      id: '/_main/settings/_layout/devices/payment-terminals'
      path: '/devices/payment-terminals'
      fullPath: '/settings/devices/payment-terminals'
      preLoaderRoute: typeof MainSettingsLayoutDevicesPaymentTerminalsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/devices/handhelds': {
      id: '/_main/settings/_layout/devices/handhelds'
      path: '/devices/handhelds'
      fullPath: '/settings/devices/handhelds'
      preLoaderRoute: typeof MainSettingsLayoutDevicesHandheldsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/devices/base-stations': {
      id: '/_main/settings/_layout/devices/base-stations'
      path: '/devices/base-stations'
      fullPath: '/settings/devices/base-stations'
      preLoaderRoute: typeof MainSettingsLayoutDevicesBaseStationsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/communication/messages': {
      id: '/_main/settings/_layout/communication/messages'
      path: '/communication/messages'
      fullPath: '/settings/communication/messages'
      preLoaderRoute: typeof MainSettingsLayoutCommunicationMessagesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/cash-register/ticket': {
      id: '/_main/settings/_layout/cash-register/ticket'
      path: '/cash-register/ticket'
      fullPath: '/settings/cash-register/ticket'
      preLoaderRoute: typeof MainSettingsLayoutCashRegisterTicketRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/bookings/special-days': {
      id: '/_main/settings/_layout/bookings/special-days'
      path: '/bookings/special-days'
      fullPath: '/settings/bookings/special-days'
      preLoaderRoute: typeof MainSettingsLayoutBookingsSpecialDaysRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/bookings/shifts': {
      id: '/_main/settings/_layout/bookings/shifts'
      path: '/bookings/shifts'
      fullPath: '/settings/bookings/shifts'
      preLoaderRoute: typeof MainSettingsLayoutBookingsShiftsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/bookings/services': {
      id: '/_main/settings/_layout/bookings/services'
      path: '/bookings/services'
      fullPath: '/settings/bookings/services'
      preLoaderRoute: typeof MainSettingsLayoutBookingsServicesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/bookings/booking-widget': {
      id: '/_main/settings/_layout/bookings/booking-widget'
      path: '/bookings/booking-widget'
      fullPath: '/settings/bookings/booking-widget'
      preLoaderRoute: typeof MainSettingsLayoutBookingsBookingWidgetRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/account/invoices': {
      id: '/_main/settings/_layout/account/invoices'
      path: '/account/invoices'
      fullPath: '/settings/account/invoices'
      preLoaderRoute: typeof MainSettingsLayoutAccountInvoicesRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/account/contracts': {
      id: '/_main/settings/_layout/account/contracts'
      path: '/account/contracts'
      fullPath: '/settings/account/contracts'
      preLoaderRoute: typeof MainSettingsLayoutAccountContractsRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
    '/_main/settings/_layout/online-orders/shifts/': {
      id: '/_main/settings/_layout/online-orders/shifts/'
      path: '/online-orders/shifts'
      fullPath: '/settings/online-orders/shifts'
      preLoaderRoute: typeof MainSettingsLayoutOnlineOrdersShiftsIndexRouteImport
      parentRoute: typeof MainSettingsLayoutRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface MainBookingsLayoutRouteChildren {
  MainBookingsLayoutGuestPlanningRoute: typeof MainBookingsLayoutGuestPlanningRoute
  MainBookingsLayoutIndexcopyRoute: typeof MainBookingsLayoutIndexcopyRoute
  MainBookingsLayoutTablePlanningRoute: typeof MainBookingsLayoutTablePlanningRoute
  MainBookingsLayoutIndexRoute: typeof MainBookingsLayoutIndexRoute
}

const MainBookingsLayoutRouteChildren: MainBookingsLayoutRouteChildren = {
  MainBookingsLayoutGuestPlanningRoute: MainBookingsLayoutGuestPlanningRoute,
  MainBookingsLayoutIndexcopyRoute: MainBookingsLayoutIndexcopyRoute,
  MainBookingsLayoutTablePlanningRoute: MainBookingsLayoutTablePlanningRoute,
  MainBookingsLayoutIndexRoute: MainBookingsLayoutIndexRoute,
}

const MainBookingsLayoutRouteWithChildren =
  MainBookingsLayoutRoute._addFileChildren(MainBookingsLayoutRouteChildren)

interface MainBookingsRouteChildren {
  MainBookingsLayoutRoute: typeof MainBookingsLayoutRouteWithChildren
}

const MainBookingsRouteChildren: MainBookingsRouteChildren = {
  MainBookingsLayoutRoute: MainBookingsLayoutRouteWithChildren,
}

const MainBookingsRouteWithChildren = MainBookingsRoute._addFileChildren(
  MainBookingsRouteChildren,
)

interface MainReportsLayoutRouteChildren {
  MainReportsLayoutCategoryRoute: typeof MainReportsLayoutCategoryRoute
  MainReportsLayoutClosingRoute: typeof MainReportsLayoutClosingRoute
  MainReportsLayoutDayRoute: typeof MainReportsLayoutDayRoute
  MainReportsLayoutEmployeeRoute: typeof MainReportsLayoutEmployeeRoute
  MainReportsLayoutLabourRoute: typeof MainReportsLayoutLabourRoute
  MainReportsLayoutMonthRoute: typeof MainReportsLayoutMonthRoute
  MainReportsLayoutMutationRoute: typeof MainReportsLayoutMutationRoute
  MainReportsLayoutProductRoute: typeof MainReportsLayoutProductRoute
  MainReportsLayoutReceiptRoute: typeof MainReportsLayoutReceiptRoute
  MainReportsLayoutVatRoute: typeof MainReportsLayoutVatRoute
  MainReportsLayoutWeekRoute: typeof MainReportsLayoutWeekRoute
  MainReportsLayoutIndexRoute: typeof MainReportsLayoutIndexRoute
}

const MainReportsLayoutRouteChildren: MainReportsLayoutRouteChildren = {
  MainReportsLayoutCategoryRoute: MainReportsLayoutCategoryRoute,
  MainReportsLayoutClosingRoute: MainReportsLayoutClosingRoute,
  MainReportsLayoutDayRoute: MainReportsLayoutDayRoute,
  MainReportsLayoutEmployeeRoute: MainReportsLayoutEmployeeRoute,
  MainReportsLayoutLabourRoute: MainReportsLayoutLabourRoute,
  MainReportsLayoutMonthRoute: MainReportsLayoutMonthRoute,
  MainReportsLayoutMutationRoute: MainReportsLayoutMutationRoute,
  MainReportsLayoutProductRoute: MainReportsLayoutProductRoute,
  MainReportsLayoutReceiptRoute: MainReportsLayoutReceiptRoute,
  MainReportsLayoutVatRoute: MainReportsLayoutVatRoute,
  MainReportsLayoutWeekRoute: MainReportsLayoutWeekRoute,
  MainReportsLayoutIndexRoute: MainReportsLayoutIndexRoute,
}

const MainReportsLayoutRouteWithChildren =
  MainReportsLayoutRoute._addFileChildren(MainReportsLayoutRouteChildren)

interface MainReportsRouteChildren {
  MainReportsLayoutRoute: typeof MainReportsLayoutRouteWithChildren
}

const MainReportsRouteChildren: MainReportsRouteChildren = {
  MainReportsLayoutRoute: MainReportsLayoutRouteWithChildren,
}

const MainReportsRouteWithChildren = MainReportsRoute._addFileChildren(
  MainReportsRouteChildren,
)

interface MainSettingsLayoutRouteChildren {
  MainSettingsLayoutAppearanceRoute: typeof MainSettingsLayoutAppearanceRoute
  MainSettingsLayoutCompanyRoute: typeof MainSettingsLayoutCompanyRoute
  MainSettingsLayoutEmailRoute: typeof MainSettingsLayoutEmailRoute
  MainSettingsLayoutEmployeeGroupsRoute: typeof MainSettingsLayoutEmployeeGroupsRoute
  MainSettingsLayoutEmployeesRoute: typeof MainSettingsLayoutEmployeesRoute
  MainSettingsLayoutFloorPlanRoute: typeof MainSettingsLayoutFloorPlanRoute
  MainSettingsLayoutPaymentMethodsRoute: typeof MainSettingsLayoutPaymentMethodsRoute
  MainSettingsLayoutPricesRoute: typeof MainSettingsLayoutPricesRoute
  MainSettingsLayoutPrintRoutesRoute: typeof MainSettingsLayoutPrintRoutesRoute
  MainSettingsLayoutSectionsRoute: typeof MainSettingsLayoutSectionsRoute
  MainSettingsLayoutTableCombinationsRoute: typeof MainSettingsLayoutTableCombinationsRoute
  MainSettingsLayoutTablesRoute: typeof MainSettingsLayoutTablesRoute
  MainSettingsLayoutVatRatesRoute: typeof MainSettingsLayoutVatRatesRoute
  MainSettingsLayoutIndexRoute: typeof MainSettingsLayoutIndexRoute
  MainSettingsLayoutAccountContractsRoute: typeof MainSettingsLayoutAccountContractsRoute
  MainSettingsLayoutAccountInvoicesRoute: typeof MainSettingsLayoutAccountInvoicesRoute
  MainSettingsLayoutBookingsBookingWidgetRoute: typeof MainSettingsLayoutBookingsBookingWidgetRoute
  MainSettingsLayoutBookingsServicesRoute: typeof MainSettingsLayoutBookingsServicesRoute
  MainSettingsLayoutBookingsShiftsRoute: typeof MainSettingsLayoutBookingsShiftsRoute
  MainSettingsLayoutBookingsSpecialDaysRoute: typeof MainSettingsLayoutBookingsSpecialDaysRoute
  MainSettingsLayoutCashRegisterTicketRoute: typeof MainSettingsLayoutCashRegisterTicketRoute
  MainSettingsLayoutCommunicationMessagesRoute: typeof MainSettingsLayoutCommunicationMessagesRoute
  MainSettingsLayoutDevicesBaseStationsRoute: typeof MainSettingsLayoutDevicesBaseStationsRoute
  MainSettingsLayoutDevicesHandheldsRoute: typeof MainSettingsLayoutDevicesHandheldsRoute
  MainSettingsLayoutDevicesPaymentTerminalsRoute: typeof MainSettingsLayoutDevicesPaymentTerminalsRoute
  MainSettingsLayoutDevicesPrintersRoute: typeof MainSettingsLayoutDevicesPrintersRoute
  MainSettingsLayoutIntegrationsMollieRoute: typeof MainSettingsLayoutIntegrationsMollieRoute
  MainSettingsLayoutAccountIndexRoute: typeof MainSettingsLayoutAccountIndexRoute
  MainSettingsLayoutCashLocationsIndexRoute: typeof MainSettingsLayoutCashLocationsIndexRoute
  MainSettingsLayoutCashRegisterIndexRoute: typeof MainSettingsLayoutCashRegisterIndexRoute
  MainSettingsLayoutCoursesIndexRoute: typeof MainSettingsLayoutCoursesIndexRoute
  MainSettingsLayoutIntegrationsIndexRoute: typeof MainSettingsLayoutIntegrationsIndexRoute
  MainSettingsLayoutLabelsIndexRoute: typeof MainSettingsLayoutLabelsIndexRoute
  MainSettingsLayoutModifierGroupsIndexRoute: typeof MainSettingsLayoutModifierGroupsIndexRoute
  MainSettingsLayoutModifiersIndexRoute: typeof MainSettingsLayoutModifiersIndexRoute
  MainSettingsLayoutMutationCategoriesIndexRoute: typeof MainSettingsLayoutMutationCategoriesIndexRoute
  MainSettingsLayoutOnlineOrdersIndexRoute: typeof MainSettingsLayoutOnlineOrdersIndexRoute
  MainSettingsLayoutProductCategoriesIndexRoute: typeof MainSettingsLayoutProductCategoriesIndexRoute
  MainSettingsLayoutProductsIndexRoute: typeof MainSettingsLayoutProductsIndexRoute
  MainSettingsLayoutOnlineOrdersShiftsIndexRoute: typeof MainSettingsLayoutOnlineOrdersShiftsIndexRoute
}

const MainSettingsLayoutRouteChildren: MainSettingsLayoutRouteChildren = {
  MainSettingsLayoutAppearanceRoute: MainSettingsLayoutAppearanceRoute,
  MainSettingsLayoutCompanyRoute: MainSettingsLayoutCompanyRoute,
  MainSettingsLayoutEmailRoute: MainSettingsLayoutEmailRoute,
  MainSettingsLayoutEmployeeGroupsRoute: MainSettingsLayoutEmployeeGroupsRoute,
  MainSettingsLayoutEmployeesRoute: MainSettingsLayoutEmployeesRoute,
  MainSettingsLayoutFloorPlanRoute: MainSettingsLayoutFloorPlanRoute,
  MainSettingsLayoutPaymentMethodsRoute: MainSettingsLayoutPaymentMethodsRoute,
  MainSettingsLayoutPricesRoute: MainSettingsLayoutPricesRoute,
  MainSettingsLayoutPrintRoutesRoute: MainSettingsLayoutPrintRoutesRoute,
  MainSettingsLayoutSectionsRoute: MainSettingsLayoutSectionsRoute,
  MainSettingsLayoutTableCombinationsRoute:
    MainSettingsLayoutTableCombinationsRoute,
  MainSettingsLayoutTablesRoute: MainSettingsLayoutTablesRoute,
  MainSettingsLayoutVatRatesRoute: MainSettingsLayoutVatRatesRoute,
  MainSettingsLayoutIndexRoute: MainSettingsLayoutIndexRoute,
  MainSettingsLayoutAccountContractsRoute:
    MainSettingsLayoutAccountContractsRoute,
  MainSettingsLayoutAccountInvoicesRoute:
    MainSettingsLayoutAccountInvoicesRoute,
  MainSettingsLayoutBookingsBookingWidgetRoute:
    MainSettingsLayoutBookingsBookingWidgetRoute,
  MainSettingsLayoutBookingsServicesRoute:
    MainSettingsLayoutBookingsServicesRoute,
  MainSettingsLayoutBookingsShiftsRoute: MainSettingsLayoutBookingsShiftsRoute,
  MainSettingsLayoutBookingsSpecialDaysRoute:
    MainSettingsLayoutBookingsSpecialDaysRoute,
  MainSettingsLayoutCashRegisterTicketRoute:
    MainSettingsLayoutCashRegisterTicketRoute,
  MainSettingsLayoutCommunicationMessagesRoute:
    MainSettingsLayoutCommunicationMessagesRoute,
  MainSettingsLayoutDevicesBaseStationsRoute:
    MainSettingsLayoutDevicesBaseStationsRoute,
  MainSettingsLayoutDevicesHandheldsRoute:
    MainSettingsLayoutDevicesHandheldsRoute,
  MainSettingsLayoutDevicesPaymentTerminalsRoute:
    MainSettingsLayoutDevicesPaymentTerminalsRoute,
  MainSettingsLayoutDevicesPrintersRoute:
    MainSettingsLayoutDevicesPrintersRoute,
  MainSettingsLayoutIntegrationsMollieRoute:
    MainSettingsLayoutIntegrationsMollieRoute,
  MainSettingsLayoutAccountIndexRoute: MainSettingsLayoutAccountIndexRoute,
  MainSettingsLayoutCashLocationsIndexRoute:
    MainSettingsLayoutCashLocationsIndexRoute,
  MainSettingsLayoutCashRegisterIndexRoute:
    MainSettingsLayoutCashRegisterIndexRoute,
  MainSettingsLayoutCoursesIndexRoute: MainSettingsLayoutCoursesIndexRoute,
  MainSettingsLayoutIntegrationsIndexRoute:
    MainSettingsLayoutIntegrationsIndexRoute,
  MainSettingsLayoutLabelsIndexRoute: MainSettingsLayoutLabelsIndexRoute,
  MainSettingsLayoutModifierGroupsIndexRoute:
    MainSettingsLayoutModifierGroupsIndexRoute,
  MainSettingsLayoutModifiersIndexRoute: MainSettingsLayoutModifiersIndexRoute,
  MainSettingsLayoutMutationCategoriesIndexRoute:
    MainSettingsLayoutMutationCategoriesIndexRoute,
  MainSettingsLayoutOnlineOrdersIndexRoute:
    MainSettingsLayoutOnlineOrdersIndexRoute,
  MainSettingsLayoutProductCategoriesIndexRoute:
    MainSettingsLayoutProductCategoriesIndexRoute,
  MainSettingsLayoutProductsIndexRoute: MainSettingsLayoutProductsIndexRoute,
  MainSettingsLayoutOnlineOrdersShiftsIndexRoute:
    MainSettingsLayoutOnlineOrdersShiftsIndexRoute,
}

const MainSettingsLayoutRouteWithChildren =
  MainSettingsLayoutRoute._addFileChildren(MainSettingsLayoutRouteChildren)

interface MainSettingsRouteChildren {
  MainSettingsLayoutRoute: typeof MainSettingsLayoutRouteWithChildren
}

const MainSettingsRouteChildren: MainSettingsRouteChildren = {
  MainSettingsLayoutRoute: MainSettingsLayoutRouteWithChildren,
}

const MainSettingsRouteWithChildren = MainSettingsRoute._addFileChildren(
  MainSettingsRouteChildren,
)

interface MainRouteChildren {
  MainIndexRoute: typeof MainIndexRoute
  MainBookingsRoute: typeof MainBookingsRouteWithChildren
  MainReportsRoute: typeof MainReportsRouteWithChildren
  MainSettingsRoute: typeof MainSettingsRouteWithChildren
  MainAdminIndexRoute: typeof MainAdminIndexRoute
  MainCashRegisterIndexRoute: typeof MainCashRegisterIndexRoute
  MainCustomersIndexRoute: typeof MainCustomersIndexRoute
  MainFloorPlanIndexRoute: typeof MainFloorPlanIndexRoute
  MainOnlineOrdersIndexRoute: typeof MainOnlineOrdersIndexRoute
  MainAdminImporterIndexRoute: typeof MainAdminImporterIndexRoute
  MainAdminMerchantsIndexRoute: typeof MainAdminMerchantsIndexRoute
  MainAdminQrIndexRoute: typeof MainAdminQrIndexRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainIndexRoute: MainIndexRoute,
  MainBookingsRoute: MainBookingsRouteWithChildren,
  MainReportsRoute: MainReportsRouteWithChildren,
  MainSettingsRoute: MainSettingsRouteWithChildren,
  MainAdminIndexRoute: MainAdminIndexRoute,
  MainCashRegisterIndexRoute: MainCashRegisterIndexRoute,
  MainCustomersIndexRoute: MainCustomersIndexRoute,
  MainFloorPlanIndexRoute: MainFloorPlanIndexRoute,
  MainOnlineOrdersIndexRoute: MainOnlineOrdersIndexRoute,
  MainAdminImporterIndexRoute: MainAdminImporterIndexRoute,
  MainAdminMerchantsIndexRoute: MainAdminMerchantsIndexRoute,
  MainAdminQrIndexRoute: MainAdminQrIndexRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  AboutRoute: AboutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
